/* eslint-disable @sailor/i18n-no-country-codes */
import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from '@sailor/i18n-web'
import { Icon, Tooltip } from '@roo/roo'
import styles from './ContactFloat.module.less'
import base64Img from '@/common/utils/base64Img'
import ServiceSvg from '../Icons/ServiceSvg'
import { getRegion } from '@/common/utils/i18nFuncs'

const REGION_CONFIG = {
  'HK': {
    'phone': '+852 21079500',
    'email': 'myservice_customer@mykeeta.com',
  },
}
const currentConfig = REGION_CONFIG[getRegion()]

const ContactFloat: React.FC = () => {
  const { t } = useTranslation()
  if (!currentConfig) return null
  return (
    <div className={styles.contactFloatContainer}>
      <Tooltip   effect="light" placement="left"
        popupStyle={{ maxWidth: '360px' }}
        content={
          <div className={styles.contactPopup} >
            <div className={styles.contactTitle}>{t('ent_o_nav_contact', 'Contact us')}</div>
            <div className={styles.contactItem}>
              <img src={base64Img.phone} alt="" />
              <div className={styles.contactInfo}>
                <div className={styles.contactPrimary}>{currentConfig.phone}</div>
                <div className={styles.contactSecondary}>{t('e_pc_phone_service_time', '08:00-23:00 every day')}</div>
              </div>
            </div>
            <div className={styles.contactItem}>
              <img src={base64Img.email} alt="" />
              <div className={styles.contactInfo}>
                <div className={styles.contactPrimary}>{currentConfig.email}</div>
                <div className={styles.contactSecondary}>{t('e_pc_email_service_time', 'Response within 3-5 business days (non-real-time service)')}</div>
              </div>
            </div>
          </div>
        }>
        <div className={styles.contactTrigger} >
          <ServiceSvg  />
        </div>
      </Tooltip>


    </div>
  )
}

export default ContactFloat
